import { ContentPaste } from "@mui/icons-material";
import * as yup from "yup";

export const departmentCreationStepsInfo = [
  { icon: ContentPaste, title: "Department Details" },
];

export const departmentEditStepsInfo = [
  { icon: ContentPaste, title: "Department Details" },
];

export const departmentCreateInitData = {
  name: "",
  expiresIn: "",
  expiresOn: "",
  maxAmount: "",
};

const departmentCreationValidationFirstStep = {
  name: yup.string().required("Name is required"),
  expiresIn: yup.number().required("Expiry Days is required"),
  expiresOn: yup.string().required("Expiry Dependency Field is required"),
  maxAmount: yup.number().required("Max Approved Amount is required"),
};

export const departmentCreationValidationSchema = [
  yup.object().shape({ ...departmentCreationValidationFirstStep }),
];
